import { Link } from 'react-router-dom'
import classNames from 'classnames'
import style from './index.module.scss'

export function MainFooter() {
    return (
        <footer className={classNames(style.main__footer)}>
            <div className={'container'}>
                <div className={style.main__footer__left}>
                    <h2>Omanhash.om</h2>
                    <p>
                        © 2025 Frontier Technology LLC.
                        <br />
                        All rights reserved.
                    </p>
                </div>
                <div className={style.main__footer__divider}></div>
                <div className={style.main__footer__links}>
                    <div className={style.main__footer__links__item}>
                        <h2>About us </h2>
                        <ul>
                            <li>
                                <a
                                    href="https://frontech.om/about/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    About Us
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://jobs.frontech.om/jobs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Careers
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://frontech.om/contact-us/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className={style.main__footer__links__item}>
                        <h2>User Support </h2>
                        <ul>
                            <li>
                                <Link to="/policy/en">Privacy policy</Link>
                            </li>
                            <li>
                                <Link to="/terms-in-use/en">Terms of Use</Link>
                            </li>
                            <li>
                                <Link to="/faq">FAQ</Link>
                            </li>
                            <li>
                                <Link to="/user-guide">User Guide</Link>
                            </li>
                        </ul>
                    </div>
                    <div className={style.main__footer__links__item}>
                        <h2>Connect</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://x.com/FRONTECH_OM"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Twitter
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/frontech_om/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Instagram
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/frontech-om/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Linkedin
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

